import { Modal, Typography, Box, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const SuccessDialog = ({ open, handleClose, message }) => {
    return(
        <>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="confirm-modal-title"
                aria-describedby="confirm-modal-description"
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: "white",
                    padding: "32px 32px 12px",
                    borderRadius: 2,
                    width: "350px",
                    textAlign: "center",
                  }}
                >
                  <Box
                    sx={{
                      borderRadius: "50%",
                      textAlign: "center",
                      marginLeft: "40%",
                      width: "20%",
                    }}
                  >
                    <CheckCircleIcon sx={{ width: "100%", height: "100%", color: "green" }} />
                  </Box>
                  <Box
                    sx={{
                      paddingTop: "10px",
                      backgroundColor: "#ffffff",
                      textAlign: "center",
                    }}
                  >
                    <Typography variant="body1" sx={{ marginBottom: "24px", color: "#555555" }}>
                      {message}
                    </Typography>
                    <Box sx={{ paddingBottom: "15px" }}>
                        <Button
                            onClick={handleClose}
                            variant="outlined"
                            sx={{
                                flex: 1,
                                borderRadius: "8px",
                                fontWeight: "bold",  
                                width: "45%", 
                                backgroundColor: "#007BFF",
                                color: "#FFFFFF",                    
                            }}
                        >
                            OK
                        </Button>
                    </Box>
                  </Box>
                </Box>
            </Modal>
        </>
    )
}

export default SuccessDialog